<template>
	<div class="binding-body">
		<div class="cusos-add-search">
			<div class="search-box">
				<div class="input-box">
					<span>商品名称：</span>
					<el-input v-model="productName" placeholder="请输入商品名称" class="name-input" size="mini"
						@keyup.enter.native="search"></el-input>
				</div>
				<div class="input-box">
					<span>SPU编号：</span>
					<el-input v-model="pcode" placeholder="请输入SPU编号" class="name-input" @keyup.enter.native="search"
						size="mini"></el-input>
				</div>
				<div class="input-box">
					<span>三方编号：</span>
					<el-input v-model="matchcode" placeholder="请输入三方编号" class="name-input" @keyup.enter.native="search"
						size="mini"></el-input>
				</div>
				<div class="input-box">
					<span>店铺级大类：</span>
					<el-select v-model="bcId" class="name-input" size='small' @change="bcChange">
						<el-option value="0" label="全部"></el-option>
						<template v-for="(item) in bc">
							<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id" />
						</template>
					</el-select>
				</div>
				<div class="input-box" v-if="bigcategoryview === 1">
					<span>店铺级小类：</span>
					<el-select v-model="scId" class="name-input" size='small'>
						<el-option value="0" label="全部"></el-option>
						<template v-for="(item) in sc">
							<el-option :value="item.id" :label="item.name" :key="item.id"></el-option>
						</template>
					</el-select>
				</div>
				<div class="input-box">
					<span>私密状态：</span>
					<el-select v-model="privateproductFlag" class="name-input" placeholder="请选择私密状态"
						size='small'>
						<el-option :value="-1" label="全部"></el-option>
						<el-option :value="0" label="公开"></el-option>
						<el-option :value="1" label="私密"></el-option>
					</el-select>
				</div>
				<div class="input-box">
					<span>销售门店：</span>
					<el-select size="small" class="name-input" v-model="shopIds" filterable multiple collapse-tags
						placeholder="请选择门店名称">
						<template v-for="item in shopNameList">
							<el-option :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</template>
					</el-select>
				</div>
			</div>
			<div class="input-box-btn">
				<el-button type="primary" class="search-btn" size="mini" @click="search">查询</el-button>
				<el-button class="search-btn" size="mini" plain @click="clear">清空</el-button>
			</div>
		</div>
		<div class="table-box">
			<el-table :stripe='true' class="grid-content" :data="tableData" size='mini' :height="tableHeight" border
				ref="table" @select="handleSelectionChange" @select-all="handleSelectionChange">
				<el-table-column fixed='left' type="selection" align="center" width="55">
				</el-table-column>
				<el-table-column prop="productName" label="商品名称" align="center" min-width="180">
					<template slot-scope="scope">
						<div style="white-space: pre-wrap">{{ scope.row.productName }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="productCode" label="SPU编号" align="center" min-width="180">
				</el-table-column>
				<el-table-column prop="prodcutMatchCode" label="三方编号" align="center" min-width="180">
				</el-table-column>
				<el-table-column prop="hiddenFlag" label="私密状态" align="center" min-width="100">
					<template slot-scope="scope">
						<span v-if="!scope.row.hiddenFlag">公开</span>
						<span v-else>私密</span>
					</template>
				</el-table-column>
				<el-table-column prop="shopName" label="销售门店" align="center" min-width="180">
				</el-table-column>
				<el-table-column prop="bigCategoryName" label="店铺级大类" align="center" min-width="180">
				</el-table-column>
				<el-table-column prop="smallCategoryName" v-if="bigcategoryview === 1" label="店铺级小类" align="center"
					min-width="180">
				</el-table-column>
			</el-table>
			<div class="page-box">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="page.number" :page-sizes="[20, 40, 60, 100, 300]" :page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
		<div class="binding-foot">
			<el-button class="fx-big-btn" size='small' @click="cancelClick">取消</el-button>
			<el-button class="fx-big-btn" type="primary" size='small' @click="saveClick">确认</el-button>
		</div>
	</div>
</template>
<script>
export default {
	name: 'addModal',
	props: {
		addModal: Boolean,
		customerName: String,
		customerId: String
	},
	data () {
		return {
			// privateproductflag: 0,
			bcId: '0',
			scId: '0',
			bc: [],
			sc: [],
			// shopid: '',
			shopList: [],
			productName: '',
			tableData: [],
			total: 0,
			page: {
				number: 1,
				size: 20
			},
			tableHeight: '90%',
			bigcategoryview: 0,
			privateproductFlag: -1,
			pcode: '',
			matchcode: '',
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'id',
				selectHandler: this.tableSelectUtilsHandler
			}),
			shopNameList: [],
			shopIds: []
		}
	},
	watch: {
		addModal: {
			handler (val) {
				if (val) {
					this.productName = ''
					this.privateproductFlag = -1
					this.pcode = ''
					this.matchcode = ''
					this.shopIds = []
					this.getShop()
					this.getBigCategory()
					this.getShopList()
					if (this.bigcategoryview === 1) {
						this.getSmalCategory()
					}
				}
			},
			immediate: true
		}
	},
	created () {
		this.checkSmallCategory()
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
		},
		tableSelectUtilsHandler (row) {
			return {
				productId: row.productId,
				shopName: row.shopName,
				shopId: row.shopId,
				id: row.id,
				name: row.productName,
				customerId: this.customerId,
				orderGoodsType: 0,
				orderGoodsTimeFlag: 0
			}
		},
		// 是否开启小类
		checkSmallCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.bigcategoryview = res.bigcategoryview
			})
		},
		bcChange () {
			this.scId = '0'
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		getSmalCategory () {
			let params = {
				pid: this.bcId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		cancelClick () {
			this.$emit('cancel', false)
		},
		saveClick () {
			let a = this.ids
			if (a.length === 0) {
				this.$message.error('请选择商品！')
				return false
			}
			// }
			let logArr = this.ids.map(e => {
				return `【${e.name}，${e.shopName}，每天订货,不限制】`
			})
			let msg = `“客户：${this.customerName}”新增“订货方案：` + logArr.join(',')
			let url = window.location.href.split('?')[0]
			url = url.replace(window.location.origin, '').substring(1)
			a.forEach(item => {
				delete item.id
				delete item.name
			})
			let params = {
				pogdDTOs: a,
				logMessage: {
					message: msg,
					referer: url
				}
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/saveOrUpdateProductOrderGoodsDate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.tableSelectUtils.clear()
					this.tableReload()
				} else {
					this.$message.error(res.message)
				}
			})
		},
		search () {
			this.tableSelectUtils.clear()
			this.page = {
				number: 1,
				size: 20
			}
			this.tableReload()
		},
		clear () {
			this.productName = ''
			this.pcode = ''
			this.matchcode = ''
			this.bcId = '0'
			this.scId = '0'
			this.privateproductFlag = -1
			this.shopIds = []
			this.search()
		},
		getShop () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getAllShopBySyscodeId`
			}).then(res => {
				if (res.result) {
					this.shopList = res.data
					// if (res.data.length > 0) {
					// 	this.shopid = res.data[0].id
					// }
					this.$nextTick(() => {
						this.tableReload()
					})
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		tableReload () {
			let params = {
				bigCategoryId: this.bcId,
				smallCategoryId: this.scId,
				productName: this.productName,
				customerId: this.customerId,
				page: this.page.number,
				size: this.page.size,
				hiddenFlag: this.privateproductFlag, // 商品私密状态
				productCode: this.pcode,
				productMatchCode: this.matchcode, // 三方编号
				shopIds: this.shopIds
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/customer/getOrderGoodsDateProductInfo`,
				data: params
			}).then(res => {
				res.recordList = res.recordList ? res.recordList : []
				res.recordList.forEach(item => {
					item.id = item.productId + item.shopId
				})
				this.total = res.recordCount
				this.tableData = res.recordList
				this.$nextTick(() => {
					this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
				})
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		},
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/selectShopList`
			}).then(res => {
				this.shopNameList = res
				console.log(res)
			})
		}
	}
}
</script>
<style lang="stylus" scoped>

.binding-body{
    display: flex;
    width :1150px;
	flex-direction: column;
    height :640px;
    overflow-y :auto;
	.cusos-add-search {
		width:100%;
        border-bottom :1px solid #f1f1f1;
		line-height :40px;
		display:flex;
	}
	.search-box{
		padding-bottom :10px;
		// height :40px;
		display:flex;
		flex-wrap:wrap;
		.input-box{
			// width :250px;
			margin-bottom:10px
			.name-input {
				width: 150px;
				margin-right: 10px;
			}
		}
	}
	.input-box-btn{
		width: 150px;
		flex-shrink: 0
	}
    .table-box{
		width :100%;
        padding-bottom :10px;
        height:calc(100% - 155px);
		.page-box{
			margin-top:10px
			text-align :center
		}
    }
    border-radius :0px 0px 10px 10px;
    .btn-box{
        width :90%;
        padding :10px;
        text-align :left
    }
    .binding-foot{
        position: relative;
        height :40px;
		margin-top:10px;
        margin-bottom :10px;
        width :100%
        .btn{
            width :35%;
			margin-left:30px;
        }
    }
}

</style>
<style lang="stylus">
.binding-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
